import { motion } from "framer-motion";
import {
  CurrencyEur,
  Handshake,
  ChartLineUp,
  Gauge
} from "@phosphor-icons/react";

const benefits = [
  {
    icon: CurrencyEur,
    title: "Maîtrise des coûts informatiques",
    description: "Chez E@tech, nous anticipons les problèmes et prenons des mesures préventives au lieu de nous précipiter pour les résoudre au fur et à mesure qu'ils surviennent."
  },
  {
    icon: Handshake,
    title: "Votre partenaire informatique de confiance",
    description: "Bénéficiez d'une transparence totale avec nous. Notre équipe travaillera en étroite collaboration avec vous pour garantir le bon fonctionnement et l'efficacité de tous vos processus métier. Nous sommes là pour vous aider à propulser votre établissement."
  },
  {
    icon: ChartLineUp,
    title: "Économie d'échelle",
    description: "À mesure que votre structure se développe, vous avez besoin d'un système évolutif. E@TECH vous permet de disposer d'une infrastructure informatique robuste, capable d'évoluer et de s'adapter."
  },
  {
    icon: Gauge,
    title: "Efficacité accrue",
    description: "Nous analysons tous les niveaux de votre infrastructure et mettons en œuvre des protocoles de sécurité pour protéger et optimiser votre réseau."
  }
];

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.5 }
  }
};

export default function BenefitsSection() {
  return (
    <section className="py-24 sm:py-32 bg-sky-50/50" data-testid="benefits-section">
      <div className="max-w-7xl mx-auto px-6 sm:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="font-['Outfit'] text-4xl sm:text-5xl font-bold text-blue-700 mb-4">
            AVANTAGES
          </h2>
          <p className="text-lg sm:text-xl text-sky-500 font-medium">
            Les avantages d'un partenariat avec E@TECH
          </p>
        </div>

        {/* Benefits Grid */}
        <motion.div 
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
        >
          {benefits.map((benefit, index) => (
            <motion.div
              key={index}
              variants={itemVariants}
              className="benefit-card text-center"
              data-testid={`benefit-card-${index}`}
            >
              <div className="flex justify-center mb-6">
                <div className="w-16 h-16 rounded-full bg-white shadow-md flex items-center justify-center">
                  <benefit.icon size={32} weight="duotone" className="text-sky-500" />
                </div>
              </div>
              <h3 className="font-['Outfit'] text-lg font-semibold text-blue-800 mb-4">
                {benefit.title}
              </h3>
              <p className="text-slate-600 text-sm leading-relaxed">
                {benefit.description}
              </p>
            </motion.div>
          ))}
        </motion.div>

        {/* Additional Image */}
        <motion.div 
          className="mt-16 flex justify-center"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <div className="max-w-2xl rounded-2xl overflow-hidden shadow-xl">
            <img 
              src="https://images.unsplash.com/photo-1643199187247-b3b6009bf0bb?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=800" 
              alt="Étudiants adultes utilisant la technologie"
              className="w-full h-auto"
            />
          </div>
        </motion.div>
      </div>
    </section>
  );
}
